import { render, staticRenderFns } from "./Newslist.vue?vue&type=template&id=3b8bc88e&scoped=true&"
import script from "./Newslist.vue?vue&type=script&lang=js&"
export * from "./Newslist.vue?vue&type=script&lang=js&"
import style0 from "./Newslist.vue?vue&type=style&index=0&id=3b8bc88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8bc88e",
  null
  
)

export default component.exports